import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var IsStringPipe = (function () {
    function IsStringPipe() {
    }
    IsStringPipe.prototype.transform = function (input) {
        return isString(input);
    };
    return IsStringPipe;
}());
export { IsStringPipe };
IsStringPipe.decorators = [
    { type: Pipe, args: [{ name: 'isString' },] },
];
/** @nocollapse */
IsStringPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=is-string.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-string.js
// module id = 232
// module chunks = 4